/* Brents product card behaviour (snippets/brents-product-card.liquid).
   - image slider: arrows, dots, keyboard. From 750px up it is a cross-fading stack
     and hovering the card dissolves to the second photo (Kith-style); below that it
     stays a horizontal scroll-snap track, which is what the phone frames expect.
   - colour swatches: plain links to the product in that colour, no selected state (Figma 297:9526)
   - size buttons: select size; unavailable sizes greyed
   - sizes / swatches are links to the product page with that variant (Figma "View product by
     size" 297:8767 and "by color" 297:9521)
   - "+": submits Dawn's <product-form>; without a size it enters "Select a size" mode (Figma
     281:3038): the + is replaced by the hint, sizes become toggles, and a size click adds.
   - press and hold (phones only, Figma 547:11262): stands in for hover, revealing the
     swatches and the second image. */
(function () {
  /* Desktop and tablet cross-fade; phones keep the scroll track. Matching the 750px
     breakpoint in component-brents-card.css, which owns the stacked layout. */
  var fadeQuery = window.matchMedia('(min-width: 750px)');

  function initCard(card) {
    if (card.dataset.ready) return;
    card.dataset.ready = 'true';

    /* ---------- image slider ---------- */
    var slides = card.querySelector('[data-card-slides]');
    var links = slides ? Array.prototype.slice.call(slides.children) : [];
    var dots = Array.prototype.slice.call(card.querySelectorAll('[data-card-dot]'));
    var prev = card.querySelector('[data-card-prev]');
    var next = card.querySelector('[data-card-next]');
    var current = 0;

    function stacked() {
      return !!slides && fadeQuery.matches;
    }

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      links.forEach(function (link, i) {
        link.classList.toggle('is-current', i === index);
        link.setAttribute('tabindex', i === index ? '0' : '-1');
        link.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= links.length - 1;
    }

    function goTo(index) {
      if (!slides) return;
      index = Math.max(0, Math.min(links.length - 1, index));
      if (stacked()) {
        /* nothing scrolls: setActive moves .is-current and CSS cross-fades the layers */
        setActive(index);
      } else {
        slides.scrollTo({ left: index * slides.clientWidth, behavior: 'smooth' });
      }
    }

    /* The stacked layout is applied from here, never from the markup, so a card still
       works as a plain scroll track if this script fails to load. */
    function applyMode() {
      if (!slides) return;
      /* Switch layouts with the cross-fade off. Otherwise every layer starts fading out the
         moment .is-stacked lands, and for the first 400ms of the page all of a card's photos
         ghost through each other (the "glitch" opening the Shop page, 2026-10-05). The forced
         reflow commits the new state before transitions come back two frames later. */
      slides.classList.add('is-instant');
      slides.classList.toggle('is-stacked', fadeQuery.matches);
      if (fadeQuery.matches) {
        slides.scrollLeft = 0;
      }
      setActive(0);
      void slides.offsetWidth;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          slides.classList.remove('is-instant');
        });
      });
    }

    if (slides) {
      slides.addEventListener(
        'scroll',
        function () {
          if (stacked()) return; /* the track does not move in stacked mode */
          var w = slides.clientWidth || 1;
          var index = Math.round(slides.scrollLeft / w);
          if (index !== current) setActive(index);
        },
        { passive: true }
      );
      slides.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      applyMode();
      if (fadeQuery.addEventListener) {
        fadeQuery.addEventListener('change', applyMode);
      } else if (fadeQuery.addListener) {
        fadeQuery.addListener(applyMode);
      }

      /* ---------- hover swap (Kith-style) ----------
         Entering the card dissolves to the second photo, leaving it returns to the
         first. Only the entry is scripted, so if the shopper then works the arrows or
         the dots they keep whichever photo they landed on until the pointer leaves. */
      if (links.length > 1) {
        card.addEventListener('mouseenter', function () {
          if (!stacked()) return;
          goTo(1);
        });
        card.addEventListener('mouseleave', function () {
          if (!stacked()) return;
          goTo(0);
        });
      }
    }

    /* ---------- press and hold: phones (Figma "Hold", node 547:11262) ----------
       Desktop reveals the colour swatches and the second image on hover. Touch has no hover,
       so a press-and-hold does it instead. Three things it must not break: scrolling the grid
       (any real travel cancels the press), opening the product (the click that follows a
       fired hold is swallowed), and tapping a swatch — which is why the state latches until
       the next pointer down outside the card or the next scroll, rather than reverting on
       release. */
    var HOLD_DELAY = 350; // ms before a press counts as a hold
    var HOLD_MOVE = 10; // px of travel that makes it a scroll instead
    var phone = window.matchMedia('(max-width: 749px)');
    var well = card.querySelector('.bcard__well');
    var holdTimer = 0;
    var holdOrigin = null;
    var holdFired = false;
    var held = false;

    function onOutsideHold(e) {
      if (card.contains(e.target)) return;
      setHeld(false);
    }

    function onHoldScroll() {
      setHeld(false);
    }

    function setHeld(on) {
      if (held === on) return;
      held = on;
      card.classList.toggle('is-held', on);
      if (slides) goTo(on ? 1 : 0);
      if (on) {
        document.addEventListener('pointerdown', onOutsideHold, true);
        window.addEventListener('scroll', onHoldScroll, { passive: true });
      } else {
        document.removeEventListener('pointerdown', onOutsideHold, true);
        window.removeEventListener('scroll', onHoldScroll);
      }
    }

    function cancelHold() {
      clearTimeout(holdTimer);
      holdTimer = 0;
      holdOrigin = null;
    }

    if (well) {
      well.addEventListener('pointerdown', function (e) {
        if (!phone.matches) return;
        holdOrigin = { x: e.clientX, y: e.clientY };
        holdFired = false;
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () {
          holdFired = true;
          setHeld(true);
        }, HOLD_DELAY);
      });

      well.addEventListener(
        'pointermove',
        function (e) {
          if (!holdOrigin) return;
          if (
            Math.abs(e.clientX - holdOrigin.x) > HOLD_MOVE ||
            Math.abs(e.clientY - holdOrigin.y) > HOLD_MOVE
          ) {
            cancelHold();
          }
        },
        { passive: true }
      );

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
        well.addEventListener(type, cancelHold);
      });

      card.addEventListener(
        'click',
        function (e) {
          if (!holdFired) return;
          holdFired = false; // the hold already did its job; don't open the product too
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }

    /* ---------- variants ---------- */
    var needsChoice = card.dataset.needsChoice === 'true';
    var variantsEl = card.querySelector('[data-card-variants]');
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }
    var sizeIndex = card.dataset.sizeIndex !== undefined ? parseInt(card.dataset.sizeIndex, 10) : -1;
    var colorIndex = card.dataset.colorIndex !== undefined ? parseInt(card.dataset.colorIndex, 10) : -1;
    var sizes = Array.prototype.slice.call(card.querySelectorAll('[data-card-size]'));
    var hint = card.querySelector('[data-card-hint]');
    var idInput = card.querySelector('[data-card-variant-id]');
    var addButton = card.querySelector('[data-card-add]');
    var form = card.querySelector('form');
    var productUrl = (card.querySelector('.bcard__title') || {}).getAttribute
      ? card.querySelector('.bcard__title').getAttribute('href')
      : '';
    /* swatches only link to the product in a colour, so quick-add takes the first available colour;
       a colour card (one card per colourway on the Shop page) is fixed to its own colour */
    var selectedColor = card.dataset.cardColor || null;
    var selectedSize = null;
    var selecting = false; /* true after "+" was pressed without a size (Figma "Select a size") */

    function matches(v, size, color) {
      if (sizeIndex >= 0 && size !== null && v.o[sizeIndex] !== size) return false;
      if (colorIndex >= 0 && color !== null && v.o[colorIndex] !== color) return false;
      return true;
    }

    function firstVariant(size, color) {
      var hit = variants.filter(function (v) { return matches(v, size, color); });
      return hit.find(function (v) { return v.available; }) || hit[0];
    }

    function resolveVariant() {
      if (!needsChoice) return null;
      if (sizeIndex >= 0 && selectedSize === null) return undefined;
      return firstVariant(selectedSize, selectedColor);
    }

    function sizeAvailable(size) {
      return variants.some(function (v) { return v.available && matches(v, size, selectedColor); });
    }

    /* default mode: a size links to the product page with that size (and the chosen colour) */
    function refreshSizes() {
      sizes.forEach(function (btn) {
        var size = btn.dataset.cardSize;
        var available = sizeAvailable(size);
        btn.classList.toggle('is-unavailable', !available);
        btn.setAttribute('aria-pressed', size === selectedSize ? 'true' : 'false');
        var v = firstVariant(size, selectedColor) || firstVariant(size, null);
        if (v && productUrl) btn.setAttribute('href', productUrl.split('?')[0] + '?variant=' + v.id);
      });
    }

    function applyVariant() {
      if (!needsChoice || !idInput) return;
      var v = resolveVariant();
      if (v) {
        idInput.value = v.id;
        idInput.disabled = !v.available;
        if (addButton) addButton.disabled = !v.available;
      } else {
        idInput.disabled = true;
      }
    }

    /* "Select a size" is dismissed by a click somewhere else, never by the pointer leaving
       the card (client note 2026-09-18). Bound only while the prompt is up, and in the
       capture phase so a handler that stops propagation can't swallow it. */
    function onOutsidePointer(e) {
      if (card.contains(e.target)) return;
      setSelecting(false);
    }

    function setSelecting(on) {
      selecting = on;
      card.classList.toggle('is-selecting', on);
      card.classList.toggle('is-touched', on);
      if (hint) hint.hidden = !on;
      if (on) {
        document.addEventListener('pointerdown', onOutsidePointer, true);
      } else {
        document.removeEventListener('pointerdown', onOutsidePointer, true);
        selectedSize = null;
        refreshSizes();
        applyVariant();
      }
    }

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!selecting) return; /* default: follow the link to the product in that size */
        e.preventDefault();
        if (btn.classList.contains('is-unavailable')) return;
        selectedSize = btn.dataset.cardSize;
        refreshSizes();
        applyVariant();
        if (form && idInput && !idInput.disabled) {
          form.requestSubmit ? form.requestSubmit() : addButton.click();
          setSelecting(false);
        }
      });
    });

    if (addButton && needsChoice) {
      addButton.addEventListener(
        'click',
        function (e) {
          if (resolveVariant() === undefined) {
            e.preventDefault();
            e.stopPropagation();
            setSelecting(true);
            var first = sizes.find(function (b) { return !b.classList.contains('is-unavailable'); });
            if (first) first.focus();
          }
        },
        true
      );
    }

    card.addEventListener('mouseleave', function () {
      /* while choosing a size the row has to stay up even with the pointer away from the card */
      if (selecting) return;
      card.classList.remove('is-touched');
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && selecting) {
        setSelecting(false);
        if (addButton) addButton.focus();
      }
    });

    refreshSizes();
    applyVariant();

    /* green tick after a successful add (Dawn publishes cartUpdate from product-form) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && addButton) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'product-form') return;
        if (String(event.productVariantId) !== String(idInput && idInput.value)) return;
        addButton.classList.add('is-added');
        setTimeout(function () { addButton.classList.remove('is-added'); }, 2000);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bcard]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.BrentsProductCard = { init: initAll };
})();